/* HOME HERO */
class HomeHero extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.titleElement = this.querySelector(".home-hero__title");
    this.images = this.querySelectorAll(".home-hero__illu-scooter");
    this.selectors = this.querySelectorAll(".home-hero__color");
    this.buyButton = this.querySelector(".home-hero__buy-button");
    this.backgroundImage = this.querySelector(".home-hero__background-image");
    this.newTagline = this.querySelector(".home-hero__tagline-new");
    this.#addEventListeners();
  }

  disconnectedCallback() {
    this.#removeEventListeners();
  }

  #addEventListeners() {
    this.selectors.forEach((button, index) => {
      button.addEventListener("click", () => {
        this.selectedButton = button;
        this.#handleButtonClick(button, index);
      });
    });
  }

  #removeEventListeners() {
    this.selectors.forEach((button) => {
      button.removeEventListener("click", this.bind(this.#handleButtonClick));
    });
  }

  #handleButtonClick(selectedButton, selectedButtonIndex) {
    this.#toggleSelectorClassList(selectedButton);
    this.#toggleProductImageClassList(selectedButtonIndex);
    this.#isNew(selectedButton);
    this.#handleTitle(selectedButton);
    if (this.buyButton !== null && this.buyButton !== undefined)
      this.#updateBuyButtonURL();
  }

  #toggleProductImageClassList(index) {
    this.images.forEach((product, productIndex) => {
      product.classList.toggle(
        "home-hero__illu-scooter--active",
        index === productIndex
      );
    });
  }

  #toggleSelectorClassList(selectedButton) {
    this.selectors.forEach((button) => {
      button.classList.toggle(
        "home-hero__color--active",
        selectedButton === button
      );
    });
  }

  #isNew(selectedButton) {
    const isNew = selectedButton.dataset.is_new === "true";
    this.newTagline.classList.toggle("home-hero__tagline-new--active", isNew);
    this.backgroundImage.classList.toggle(
      "home-hero__background-image--active",
      isNew
    );
  }

  #handleTitle(selectedButton) {
    if (selectedButton.dataset.custom_title !== undefined) {
      this.titleElement.textContent = selectedButton.dataset.custom_title;
    } else {
      this.titleElement.textContent = this.titleElement.dataset.title;
    }
  }

  #updateBuyButtonURL() {
    this.buyButton.href = this.selectedButton.dataset.product_url;
  }
}

customElements.define("home-hero", HomeHero);

/* PRICING LIST */
class PricingListVariantSelector extends HTMLElement {
  constructor() {
    super();
    this.pricingListId = this.dataset.pricing_list_id;
    this.pricingList = document.getElementById(this.pricingListId);
    this.variantSelectors = this.querySelectorAll(
      ".pricing-list__variant-selector-item"
    );
    this.toggle = this.querySelector(".pricing-list__variant-selector-toggle");
  }

  connectedCallback() {
    this.#addEventListeners();
  }

  disconnectedCallback() {
    this.#removeEventListeners();
  }

  #addEventListeners() {
    this.variantSelectors.forEach((variantSelector, index) => {
      variantSelector.addEventListener("click", () => {
        this.#handleVariantClick(variantSelector, index);
      });
    });
  }

  #handleVariantClick(selectedVariantSelector, selectedVariantIndex) {
    this.#toggleVariantSelectorClassList(selectedVariantSelector);
    this.#handleToggleClassList(selectedVariantIndex);
    this.#handleSliderVisibility(selectedVariantIndex);
  }

  #removeEventListeners() {
    this.variantSelectors.forEach((variantSelector) => {
      variantSelector.removeEventListener(
        "click",
        this.bind(this.#handleVariantClick)
      );
    });
  }

  #toggleVariantSelectorClassList(selectedVariantSelector) {
    this.variantSelectors.forEach((variantSelector) => {
      variantSelector.classList.toggle(
        "pricing-list__variant-selector-item--active",
        selectedVariantSelector === variantSelector
      );
    });
  }

  #handleToggleClassList(selectedIndex) {
    this.toggle.classList.toggle(
      "pricing-list__variant-selector-toggle--right",
      selectedIndex === 1
    );
  }

  #handleSliderVisibility(selectedIndex) {
    this.pricingList.selectVariant(selectedIndex);
  }
}

customElements.define(
  "pricing-list-variant-selector",
  PricingListVariantSelector
);

class PricingList extends HTMLElement {
  constructor() {
    super();
    this.variantSelectors = this.querySelectorAll(
      ".pricing-list__variant-selector-item"
    );
    this.sliders = this.querySelectorAll(".pricing-list__slider");
  }

  selectVariant(selectedIndex) {
    this.sliders.forEach((slider, index) => {
      slider.classList.toggle(
        "pricing-list__slider--active",
        index === selectedIndex
      );
    });
  }
}

customElements.define("pricing-list", PricingList);

class PressSlider extends HTMLElement {
  constructor() {
    super();
    this.backgroundImages = this.querySelectorAll(
      ".press-slider__background-image"
    );
  }

  connectedCallback() {
    this.setSlider();
  }

  setSlider() {
    this.slider = new Splide(this.querySelector(".press-slider__slider"), {
      perPage: 1,
      arrows: false,
      pagination: false,
      type: "loop",
      autoplay: true,
      interval: 5000,
      pagination: true,
    }).mount();

    this.slider.on("move", (slide) => {
      this.backgroundImages.forEach((backgroundImage, index) => {
        backgroundImage.classList.toggle(
          "press-slider__background-image--active",
          index === slide
        );
      });
    });
  }
}

customElements.define("press-slider", PressSlider);

 var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}